import * as  types from '../mutation-types'
import { unionState } from '../union-state'

export default {
    namespaced: true,
    state: {
        materials_journals: [],
        entires: [],
        materials_journal: {}
    },

    actions:{
        fetchAll({ commit }, { fromDate, toDate, warehouseId }){
            return window.axios.get('MaterialFlow/MaterialsJournals', {
                params: {
                    fromDate, 
                    toDate,
                    warehouseId
                }
            })
            .then(response => {
                commit(types.STORE_MATERIALS_JOURNALS, response.data);
                return response.data;
            })
        },

        create({ commit }, { date, warehouse_id }){
            return window.axios.post('MaterialFlow/MaterialsJournals', {
                date,
                warehouse_id
            })
            .then(response => {
                commit(types.STORE_ONE_MATERIALS_JOURNAL, response.data);
                return response.data;
            })
        },

        fetch({ commit }, { journalId }){
            return window.axios.get(`MaterialFlow/MaterialsJournals/${journalId}`)
            .then(response => {
                commit(types.STORE_ONE_MATERIALS_JOURNAL, response.data);
                return response.data;
            })
        },

        delete({ commit }, { journalId }){
            return window.axios.delete(`MaterialFlow/MaterialsJournals/${journalId}`)
            .then(response => {
                commit('', '')
                return response.data;
            })
        },

        changeToPosted({ commit }, { journalId }){
            return window.axios.put(`MaterialFlow/MaterialsJournals/${journalId}/ChangeToPosted`)
            .then(response => {
                commit('', '')
                return response.data;
            })
        },

        changeToNotPosted({ commit }, { journalId }){
            return window.axios.put(`MaterialFlow/MaterialsJournals/${journalId}/ChangeToNotPosted`)
            .then(response => {
                commit('', '')
                return response.data;
            })
        },

        fetchEntries({ commit }, { journalId }){
            return window.axios.get(`MaterialFlow/MaterialsJournals/${journalId}/Entires`)
            .then(response => {
                commit(types.STORE_MATERIALS_JOURNAL_ENTRIES, response.data);
                return response.data;
            })
        },

        createEntry({ commit }, { journalId, material_entry }){
            return window.axios.post(`MaterialFlow/MaterialsJournals/${journalId}/Entries`, {
                no: material_entry.no,
                invoice_id: material_entry.invoice_id,
                material_id: material_entry.material_id, 
                account_id: material_entry.account_id, 
                quantity: material_entry.quantity, 
                count: material_entry.count, 
                price: material_entry.price, 
                notes: material_entry.notes, 
                type: material_entry.type, 
                date: material_entry.date, 
                doc_no: material_entry.doc_no,
                materials_journal_id: material_entry.materials_journal_id
            })
            .then(response => {
                commit(types.STORE_ONE_MATERIALS_JOURNAL, response.data);
                return response.data;
            })
        },

        updateEntry({ commit }, { journalId, material_entry }){
            return window.axios.put(`MaterialFlow/MaterialsJournals/${journalId}/Entries/${material_entry.id}`, {
                id: material_entry.id,
                no: material_entry.no,
                invoice_id: material_entry.invoice_id,
                material_id: material_entry.material_id, 
                account_id: material_entry.account_id, 
                quantity: material_entry.quantity, 
                count: material_entry.count, 
                price: material_entry.price, 
                notes: material_entry.notes, 
                type: material_entry.type, 
                date: material_entry.date, 
                doc_no: material_entry.doc_no,
                materials_journal_id: material_entry.materials_journal_id,
            })
            .then(response => {
                commit(types.STORE_ONE_MATERIALS_JOURNAL, response.data);
                return response.data;
            })
        },

        deleteEntry({ commit }, { journalId, entryId }){
            return window.axios.delete(`MaterialFlow/MaterialsJournals/${journalId}/Entries/${entryId}`)
            .then(response => {
                commit(types.STORE_ONE_MATERIALS_JOURNAL, response.data);
                return response.data;
            })
        },

        fetchEntry({ commit }, entryId ){
            return window.axios.get(`MaterialFlow/MaterialsJournalEntries/${entryId}`)
            .then(response => {
                commit(types.STORE_ONE_MATERIAL_ENTRY, response.data);
                return response.data;
            })
        },

        clear({ commit }) {
            commit(types.CLEAR);
        },
    },

    mutations:{
        [types.STORE_MATERIALS_JOURNALS](state, materials_journals){
            state.materials_journals = materials_journals;
        },

        [types.STORE_MATERIALS_JOURNAL_ENTRIES](state, entires){
            state.entires = entires;
        },
        
        [types.STORE_ONE_MATERIALS_JOURNAL](state, materials_journal){
            state.materials_journal = materials_journal;
        },

        [types.STORE_ONE_MATERIAL_ENTRY](state, material_entry) {
            state.materials_journal.entries = unionState(state.materials_journal.entries, [material_entry]);
        },

        [types.CLEAR](state) {
            state.materials_journal = {}
            state.materials_journals = []
            state.entires = []
        },
    },
}